export const HOME = '/'; /* ESTO ES LA LANDING = HOME */
export const PORTFOLIO = '/portfolio';
export const ABOUT = '/about';
export const CONTACT = '/contact';
export const GITHUB = 'https://github.com/cristinapicatoste';
export const LINKEDIN = 'https://www.linkedin.com/in/cristinapicatoste/';
export const WHATSAPP = 'https://api.whatsapp.com/send?phone=34625963637';
